import { useEffect } from 'react'

export default function PayPage() {
  useEffect(() => {
    document.title = 'Subscribe to Hosting | Fugue Lab'
  }, [])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
      <h1 className="mb-2 text-3xl font-bold">Subscribe to Hosting</h1>
      <p className="text-muted-foreground mb-6">Secure hosting and domain management — $50/month</p>
      <a
        href="https://buy.stripe.com/4gMcN49ue4SkegWalWf3a00"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded bg-black px-6 py-2 text-white hover:bg-gray-800"
      >
        Subscribe for $25/month
      </a>
    </div>
  )
}
